<template>
  <div class="modal fade" id="address-modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
            aria-hidden="true">&times;</span></button>
          <h4 class="modal-title" id="myModalLabel">{{ title }} Address</h4>
        </div>
        <div class="modal-body">
          <validate-address-modal :address="localAddress" :inline="true" ref="validModal" v-on:update-address="updateAddress($event)" style="margin-bottom: 15px;" />
          <form class="form-horizontal">
            <input-error-wrapper class="form-group" :errors="fieldError.addressType">
              <label class="control-label col-sm-3">Address Type:</label>
              <div class="col-sm-9">
                <address-type-input class="required" v-model="localAddress.addressType"
                                    display-type="form" :read-only-prop="isExisting">
                  <option disabled value="">Please select one</option>
                </address-type-input>
              </div>
            </input-error-wrapper>
            <input-error-wrapper class="form-group" :errors="fieldError.address1">
              <label class="control-label col-sm-3">Street Address 1:</label>
              <div class="col-sm-9"><input type="text" class="form-control required"
                                           placeholder="Street Address 1"
                                           v-model="localAddress.address1" maxlength="55">
              </div>
            </input-error-wrapper>
            <input-error-wrapper class="form-group" :errors="fieldError.address2">
              <label class="control-label col-sm-3">Street Address 2:</label>
              <div class="col-sm-9"><input type="text" class="form-control"
                                           placeholder="Street Address 2"
                                           v-model="localAddress.address2" maxlength="55">
              </div>
            </input-error-wrapper>
            <input-error-wrapper class="form-group" :errors="fieldError.city">
              <label class="control-label col-sm-3">City:</label>
              <div class="col-sm-9"><input type="text" class="form-control required" placeholder="City"
                                           v-model="localAddress.city" maxlength="20"></div>
            </input-error-wrapper>
            <input-error-wrapper class="form-group" :errors="fieldError.state">
              <label class="control-label col-sm-3">State:</label>
              <div class="col-sm-9">
                <state-input class="required" v-model="localAddress.state"
                             display-type="form">
                  <option disabled value="">Please select one</option>
                </state-input>
              </div>
            </input-error-wrapper>
            <input-error-wrapper class="form-group" :errors="fieldError.postalCode">
              <label class="control-label col-sm-3">Postal Code:</label>
              <div class="col-sm-9"><input type="text" class="form-control required" placeholder="Postal Code"
                                           v-model="localAddress.postalCode" maxlength="11"></div>
            </input-error-wrapper>
            <input-error-wrapper class="form-group" :errors="fieldError.country" v-if="isExisting">
              <label class="control-label col-sm-3">Country:</label>
              <div class="col-sm-9"><input type="text" class="form-control" placeholder="Country"
                                           v-model="localAddress.country" disabled="disabled"></div>
            </input-error-wrapper>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-info pull-left" @click="openValidationModal()">Validate</button>
          <button type="button" class="btn btn-default" @click="close()">Close</button>
          <button type="button" class="btn btn-primary" @click="save()">Save
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {cloneDeep} from 'lodash'
import AddressTypeLovComponent from './AddressTypeLovComponent'
import StateLovComponent from './StateLovComponent'
import FormValidationMixIn from './FormValidationMixIn'
import $ from 'jquery'
import axios from 'axios'
import ValidateAddressModal from './ValidateAddressModal'

export default {
  name: 'AddressModal',
  components: {
    'address-type-input': AddressTypeLovComponent,
    'state-input': StateLovComponent,
    'validate-address-modal': ValidateAddressModal
  },
  mixins: [FormValidationMixIn],
  props: {
    address: {
      type: Object,
      required: true
    },
    saveUrl: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      localAddress: {}
    }
  },
  watch: {
    address () {
      this.reset()
    }
  },
  computed: {
    title () {
      return this.isExisting ? 'Edit' : 'Add'
    },
    isExisting () {
      return this.localAddress.compositeKeyToString && this.localAddress.compositeKeyToString.length > 0
    }
  },
  methods: {
    reset () {
      this.clearErrors()
      this.localAddress = cloneDeep(this.address)
    },
    open () {
      $('#address-modal').modal('show')
    },
    close () {
      $('#address-modal').modal('hide')
    },
    save () {
      this.clearErrors()
      $.blockUI({message: '<h3>Saving address data...</h3>'})

      axios.post(this.saveUrl, this.localAddress)
        .then(response => {
          $.unblockUI()
          if (response.data.result === 'success') {
            this.$emit('update-address', response.data.bean)
            this.close()
          }
          this.saveResponse = response.data
        })
        .catch(error => {
          console.log(error.stack)
          $.unblockUI()
          this.onError('An unexpected error occurred saving address data.')
        })
    },
    openValidationModal () {
      if (this.$refs.validModal) {
        this.$refs.validModal.open()
      }
    },
    updateAddress (address) {
      this.localAddress.address1 = address.address1
      this.localAddress.address2 = address.address2
      this.localAddress.city = address.city
      this.localAddress.state = address.state
      this.localAddress.postalCode = address.postalCode
    }
  },
  mounted () {
    this.reset()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/js/components/AddressModal.vue